import type { DocumentRevision, ChangeLogEntry } from '@/entities/Document';
import { formatCivilDateToPtBR } from '@/shared/lib';

const OBSOLETE_AUTO_MESSAGE = 'Revisão obsoletada automaticamente';

export interface DocumentHistoryViewItem extends DocumentRevision {
  effectiveDateLabel: string;
  changelogEntries: ChangeLogEntry[];
}

function getEffectiveDateLabel(revision: DocumentRevision): string {
  return formatCivilDateToPtBR(revision.effectiveDate);
}

export function buildDocumentHistoryView(
  revisions: readonly DocumentRevision[]
): DocumentHistoryViewItem[] {
  return [...revisions]
    .sort((a, b) => b.revision - a.revision)
    .map((revision) => ({
      ...revision,
      effectiveDateLabel: getEffectiveDateLabel(revision),
      changelogEntries: revision.changelogEntries.filter(
        (entry) => !entry.description.includes(OBSOLETE_AUTO_MESSAGE)
      ),
    }));
}

